import axios from "axios";
import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { HashLoader } from "react-spinners";
import Failuremessage from "./failuremessage";


export default function BookAppoint(props){

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
  const rootUrl = "http://localhost:3000";
  const localrootUrl = "https://ahkserver.onrender.com";

  const [loading,setLoading] = useState(false);
  const [resTwo, setResTwo] = useState();
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    age:"",
    cnic:"",
    gender: "male",
    dob:"",
    mobileNumber: "",
    searchResult:"",
    priceofsearch:"",
    discount:"",
    received:"",
    labnumber:"",
    infotest:"",
  });

  useEffect(()=>{
    if(props.testtoadd && formData){
      const newInfotest = props.testtoadd.join("\n"); // Join array elements with a line break
      setFormData((prev) => ({ ...prev, infotest: newInfotest }));
    }
  },[props.testtoadd])


  function formTwoSubmit(event){
    setLoading(true);
    event.preventDefault();
    const fetchData = async ()=>{
        try{
            const dataposter = await axios.post(`${localrootUrl}/logUser`,{...formData},{withCredentials:true});
        const response = dataposter.data;
        if(response){
          setLoading(false);
        }
        setResTwo(response);
        }catch(error){
            console.log(error);
            setLoading(true);
        }
    }
    fetchData();
    // setFormData({
    //   email: "",
    //   name: "",
    //   age:"",
    //   cnic:"",
    //   gender: "",
    //   dob:"",
    //   mobileNumber: "",
    //   searchResult:"",
    //   priceofsearch:"",
    //   discount:""
    // });
    // setFound([]);
    // setPriceSelect([]);
  }
  // if(loading){
  //   return(
  //     <div className="spinner-container">
  //       <ClipLoader size={150} className="loader" loading={loading} />
  //     </div>
  //   )
  // }
  function checkEmail(){
    if(formData.email.includes("@") && formData.email.includes(".com") && formData.email.length>5){
      return {"success":"Valid"};
    }else{
      return {"failure":"*Invalid Email"};
    }
  }
    return <div className="register">
    <form onSubmit={formTwoSubmit} method="POST" className="former" style={{padding:"0vw"}}>
      <h2 className="updates">
      {loading?<HashLoader size={50} className="newloader" loading={loading}/>:resTwo?resTwo.failure?<Failuremessage custommessage={resTwo.failure} isFail={true}/>:<Failuremessage successmessage={resTwo.success} isFail={false}/>:<p className="updates">Enter Patient Info</p>}
      </h2>
      <div style={{display:"flex",flexDirection:isMobile?"column":"row",gap:"2vw"}}>
        <div style={{display:"flex",flexDirection:"column",gap:"2vw"}}>
          <div className="subform">
          <div className="form-col">
              <input
              className="inputtext"
              type="text"
              name="email"
              required
              placeholder="Enter Email"
              value={formData.email}
              onChange={(event) => setFormData({ ...formData, email: event.target.value })}
              />
              <label className="label-contact" style={{color:"red"}}>{checkEmail().failure?checkEmail().failure:null}</label>
          </div>
          <div className="form-col">
              <input
              className="inputtext"
              type="text"
              name="name"
              required
              placeholder="Enter Name"
              value={formData.name}
              onChange={(event) => setFormData({ ...formData, name: event.target.value })}
              />
              <label className="label-contact" style={{color:"red"}}>{formData.name.length>=3?null:"*Name must be at least 3 characters"}</label>
          </div>
          </div>
          <div className="subform">
            <div className="form-col">
              <input
                className="inputtext"
                type="number"
                name="age"
                max={120}
                min={1}
                required
                placeholder="Enter Age"
                value={formData.age}
                onChange={(event) => setFormData({ ...formData, age: event.target.value })}
              /> 
            </div> 
            <div className="form-col">
              <input
              className="inputtext"
              type="number"
              name="mobileNumber"
              required
              placeholder="Enter Mobile Number"
              value={formData.mobileNumber}
              onChange={(event) => setFormData({ ...formData, mobileNumber: event.target.value })}
              />
              <label className="label-contact" style={{color:"red"}}>{formData.mobileNumber.length==11?null:"*Mobile Number is Invalid"}</label>
            </div>
          </div>
          {isMobile?<textarea className="inputtext" required value={formData.infotest} style={{textAlign:"left"}} onChange={(event)=>setFormData(({...formData, infotest: [...formData.infotest,event.target.value] }))} cols={50} rows={6} placeholder="Enter your Test Information..."></textarea>:null}
          <button className="submit" type="submit" disabled={checkEmail().success && formData.name.length>=3 && formData.mobileNumber.length==11 && formData.infotest.length!=0?false:true} style={checkEmail().success && formData.name.length>=3 && formData.mobileNumber.length==11 && formData.infotest.length!=0?null:{opacity:0.5,cursor:"not-allowed"}}>Submit</button>
        </div>
        {isMobile?null:<textarea className="inputtext" required value={formData.infotest} style={{textAlign:"left"}} onChange={(event)=>setFormData({...formData,infotest:event.target.value})} cols={50} rows={12} placeholder="Enter your Test Information..."></textarea>}
      </div>
    </form>
    </div>
}